import { ArrowUpRight, Copy, Mail, MapPin } from "lucide-react";
import { useState } from "react";
import { profile } from "../data/profile";
import { socialLinks } from "../data/socialLinks";
import { ContactForm } from "./ContactForm";

export function ContactSection() {
  const [copied, setCopied] = useState(false);

  async function copyEmail() {
    await navigator.clipboard.writeText(profile.email);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  }

  return (
    <section id="contact" className="contact-section">
      <div className="shell contact-grid">
        <div className="contact-copy">
          <p className="section-kicker"><span className="panel-number">08</span><span>Contact / next build</span></p>
          <h2>Let’s build something intelligent.</h2>
          <p>I am open to conversations about AI engineering, software development, computer vision, robotics, research opportunities and technically ambitious projects.</p>
          <div className="contact-direct">
            {profile.publish.email && (
              <div><Mail aria-hidden="true" /><span><small>Email</small><a href={`mailto:${profile.email}`}>{profile.email}</a></span><button type="button" onClick={copyEmail} aria-label="Copy email address"><Copy aria-hidden="true" /><span>{copied ? "Copied" : "Copy"}</span></button></div>
            )}
            {profile.publish.location && <div><MapPin aria-hidden="true" /><span><small>Based in</small>{profile.location}</span></div>}
          </div>
          <nav className="contact-links" aria-label="Professional links">
            {socialLinks.map((link) => (
              <a key={link.label} href={link.href} target={link.external ? "_blank" : undefined} rel={link.external ? "noreferrer" : undefined}>
                {link.label}{link.placeholder && <span className="todo-dot">TODO</span>}<ArrowUpRight aria-hidden="true" />
              </a>
            ))}
          </nav>
        </div>
        <ContactForm />
      </div>
    </section>
  );
}
